import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TableRowSkeleton extends Vue {
  @Prop({ default: false })
  showFull: boolean;
}
